/** Keep the configured backend, avoiding redirects between www/apex aliases.
 * Separate API hosts, protocols, ports and configured base paths are preserved.
 */
export function resolveApiBaseUrl(configuredBase, pageOrigin) {
  if (!configuredBase) throw new Error("REACT_APP_BACKEND_URL is required");
  const backend = new URL(configuredBase);
  const page = new URL(pageOrigin);
  if (!["http:", "https:"].includes(backend.protocol) || backend.username || backend.password || backend.search || backend.hash) {
    throw new Error("REACT_APP_BACKEND_URL must be an HTTP(S) base URL");
  }
  const withoutWww = (hostname) => hostname.replace(/^www\./, "");
  if (backend.protocol === page.protocol && backend.port === page.port && withoutWww(backend.hostname) === withoutWww(page.hostname)) {
    backend.hostname = page.hostname;
  }
  return `${backend.origin}${backend.pathname.replace(/\/+$/, "")}/api`;
}